import { Button, Input, Modal, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  IS_UPDATE_VERSION_3_PROJECT_LOGIN,
  KEY_LOCAL_TOUR_COMPLETE,
  KEY_LOCAL_TYPE_USER,
  TYPE_LOGIN,
  TYPE_USER,
} from "../helper/const";
import OTPInput from "react-otp-input";
import ModalNotifycation from "./ModalNotifycation";
import { useDispatch } from "react-redux";
import {
  loginWithOtp,
  loginWithPassword,
  requestOtp,
  verifyOtp,
} from "../Redux/futures/account/actions";
import { LoadingOutlined } from "@ant-design/icons";
import { setCookieChangePw } from "../utils/cookie";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";
import { handleNumericInput } from "../helper/helper";
import { useLocation, useNavigate } from "react-router";
import PATH from "@/config/PATH";

function ModalLogin({ open, setOpenModalLogin, isGetContainer = true }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [typeLogin, setTypeLogin] = useState(TYPE_LOGIN.loginPassword);
  const [showPassword, setShowPassword] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [openModalNotification, setOpenModalNotification] = useState(false);
  const [statusInput, setStatusInput] = useState({
    phoneNumber: "",
    password: "",
  });
  const [messageError, setMessageError] = useState("");
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [isErrorPhoneOtp, setIsErrorPhoneOtp] = useState(false);
  const [isLoginPW, setIsLoginPW] = useState(true);
  const [countdown, setCountdown] = useState(0);
  const [errorMessageOpt, setErrorMessageOpt] = useState("");

  const inputRefPhoneNumber = useRef(null);
  const inputRefPassWord = useRef(null);
  const inputRefPhoneNumberOtp = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // đẩy đến trang login luôn
  useEffect(() => {
    if (IS_UPDATE_VERSION_3_PROJECT_LOGIN) return;  // chặn không cho chuyển đến login, chuyển thẳng vào Home khi mở web
    if (open) {
      navigate(PATH.LOGIN, {
        state: {
          from: "minigame",
          pathlastname: !location.search ? location.pathname : `${location.pathname}${location.search}`,
        },
      });
    }
  }, [open]);

  useEffect(() => {
    if (!open && !openModalConfirm) {
      setStatusInput({
        phoneNumber: "",
        password: "",
      });
      setPassword("");
      setPhoneNumber("");
      setOtp("");
      setShowPassword(false);
    }
    if (!open) {
      setTypeLogin(TYPE_LOGIN.loginPassword);
      setMessageError("");
    }
  }, [open]);
  const afterLoginPassword = (dataSuccess, isLoading, dataError = null) => {
    if (dataSuccess?.data?.isNewUser) {
      setCookieChangePw();
    }

    if (dataSuccess?.data?.type_user) {
      localStorage.setItem(KEY_LOCAL_TYPE_USER, dataSuccess?.data?.type_user);
      const tourHistoryKey = `TOUR_SHOWN_${phoneNumber}`;
      const tourHistory = JSON.parse(
        localStorage.getItem(tourHistoryKey) || "{}",
      );

      const userTypeKey = dataSuccess?.data?.type_user.toString();

      const hasShownTourForThisUserType = tourHistory[userTypeKey];
      const isPU4EligibleType = [
        TYPE_USER.newNoPackage,
        TYPE_USER.newPackage,
        TYPE_USER.firstLoginAfterRegistered7Days,
        TYPE_USER.firstLoginWithinRegistered2To6Days,
      ].includes(+dataSuccess?.data?.type_user);
      if (
        Object.values(TYPE_USER).includes(dataSuccess?.data?.type_user) &&
        dataSuccess?.data?.type_user !== TYPE_USER.general &&
        !hasShownTourForThisUserType
      ) {
        dispatch(
          setReduxDataTypeIntroTour({
            typeActive: +dataSuccess?.data?.type_user,
            step: 0,
          }),
        );
        // console.log('login run')
        tourHistory[userTypeKey] = true;
        localStorage.setItem(tourHistoryKey, JSON.stringify(tourHistory));
      } else if (isPU4EligibleType) {
        // Weekly-repeat popup: let popupManager handle frequency, don't permanently block
        dispatch(
          setReduxDataTypeIntroTour({
            typeActive: +dataSuccess?.data?.type_user,
            step: 0,
          }),
        );
      } else {
        localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
        dispatch(
          setReduxDataTypeIntroTour({
            typeActive: TYPE_USER.general,
            step: -1,
          }),
        );
      }
    }

    if (!isLoading) {
      if (dataError) {
        setMessageError(dataError.errorMessage);
        setOpenModalNotification(true);
        setOpenModalConfirm(false);
        setIsLoginPW(false);
        // handleCancel()
      } else {

        setStatusInput({
          phoneNumber: "",
          password: "",
        });
        setPassword("");
        setPhoneNumber("");
        setOtp("");
        setShowPassword(false);
        handleCancel();
      }
    }
  };
  const afterLoginOtp = (dataSuccess, isLoading, dataError = null) => {
    if (!isLoading) {
      if (dataSuccess?.data?.isNewUser) {
        setCookieChangePw();
      }

      if (dataSuccess?.data?.type_user) {
        localStorage.setItem(KEY_LOCAL_TYPE_USER, dataSuccess?.data?.type_user);
        const tourHistoryKey = `TOUR_SHOWN_${phoneNumber}`;
        const tourHistory = JSON.parse(
          localStorage.getItem(tourHistoryKey) || "{}",
        );

        const userTypeKey = dataSuccess?.data?.type_user.toString();

        const hasShownTourForThisUserType = tourHistory[userTypeKey];
        const isPU4EligibleType = [
          TYPE_USER.newNoPackage,
          TYPE_USER.newPackage,
          TYPE_USER.firstLoginAfterRegistered7Days,
          TYPE_USER.firstLoginWithinRegistered2To6Days,
        ].includes(+dataSuccess?.data?.type_user);
        if (
          Object.values(TYPE_USER).includes(dataSuccess?.data?.type_user) &&
          dataSuccess?.data?.type_user !== TYPE_USER.general &&
          !hasShownTourForThisUserType
        ) {
          dispatch(
            setReduxDataTypeIntroTour({
              typeActive: +dataSuccess?.data?.type_user,
              step: 0,
            }),
          );
          // console.log('login run')
          tourHistory[userTypeKey] = true;
          localStorage.setItem(tourHistoryKey, JSON.stringify(tourHistory));
        } else if (isPU4EligibleType) {
          // Weekly-repeat popup: let popupManager handle frequency, don't permanently block
          dispatch(
            setReduxDataTypeIntroTour({
              typeActive: +dataSuccess?.data?.type_user,
              step: 0,
            }),
          );
        } else {
          localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
          dispatch(
            setReduxDataTypeIntroTour({
              typeActive: TYPE_USER.general,
              step: -1,
            }),
          );
        }
      }

      setStatusInput({
        phoneNumber: "",
        password: "",
      });
      setPassword("");
      setPhoneNumber("");
      setOtp("");
      setShowPassword(false);
      handleCancel();
      setOpenModalConfirm(false);
    }
  };
  const afterverifyOtp = (data, isLoading, dataError) => {
    if (!isLoading) {
      if (dataError) {
        setMessageError(dataError.errorMessage);
        setOpenModalNotification(true);
        // setOpenModalConfirm(false);
        // handleCancel()
      } else {
        const body = {
          isdnOtp: phoneNumber,
          callback: afterLoginOtp,
        };
        dispatch(loginWithOtp(body));
      }
    }
  };

  const afterRequestOtp = (data, isLoading) => {
    if (data) {
      if (!data?.success) {
        return setErrorMessageOpt(data?.message || data?.errorMessage);
      }
      const timerRequest = 180; //3 phút
      setCountdown(timerRequest);
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1 || prev < 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setErrorMessageOpt("");
      setOpenModalLogin(false);
      setOpenModalConfirm(true);
      setIsErrorPhoneOtp(false);
    } else if (!isLoading) {
      setIsErrorPhoneOtp(true);
      setErrorMessageOpt("");
    }
  };
  const handleOk = async (type) => {
    if (
      typeLogin === TYPE_LOGIN.loginPassword &&
      type !== TYPE_LOGIN.loginOtp
    ) {
      if (
        (!phoneNumber || phoneNumber.trim() === "") &&
        (!password || password.trim() === "")
      ) {
        setStatusInput({
          password: "error",
          phoneNumber: "error",
        });
        if (inputRefPhoneNumber?.current) {
          inputRefPhoneNumber?.current.focus();
        }
        return;
      }

      if (!phoneNumber || phoneNumber.trim() === "") {
        setStatusInput({
          ...statusInput,
          phoneNumber: "error",
        });
        if (inputRefPhoneNumber?.current) {
          inputRefPhoneNumber?.current.focus();
        }
        return;
      }
      if (!password || password.trim() === "") {
        setStatusInput({
          ...statusInput,
          password: "error",
        });
        if (inputRefPassWord?.current) {
          inputRefPassWord?.current.focus();
        }
        return;
      }
      setIsLoadingBtn(true);
      const body = {
        isdn: phoneNumber,
        password: password,
        callback: afterLoginPassword,
      };
      await dispatch(loginWithPassword(body));
      setIsLoadingBtn(false);
    }

    if (typeLogin === TYPE_LOGIN.loginOtp || type === TYPE_LOGIN.loginOtp) {
      if (!phoneNumber || phoneNumber.trim() === "") {
        setStatusInput({
          phoneNumber: "error",
        });
        if (inputRefPhoneNumberOtp?.current) {
          inputRefPhoneNumberOtp?.current.focus();
        }
        return;
      }
      setMessageError("");
      const body = {
        isdn: phoneNumber,
        callback: afterRequestOtp,
      };

      if (countdown) {
        setOpenModalLogin(false);
        setOpenModalConfirm(true);
        setIsErrorPhoneOtp(false);
        return null;
      }
      setIsLoadingBtn(true);
      await dispatch(requestOtp(body));
      setIsLoadingBtn(false);
    }
  };

  const handleConfirmOtp = async () => {
    if (!otp || otp.trim() === "") {
      return;
    }
    const body = {
      isdnOtp: phoneNumber,
      otp: otp,
      callback: afterverifyOtp,
    };
    setIsLoadingBtn(2);
    await dispatch(verifyOtp(body));
    setIsLoadingBtn(false);
  };
  const handleBack = () => {
    setOpenModalLogin(true);
    setOpenModalConfirm(false);
    setOtp("");
    setTypeLogin(TYPE_LOGIN.loginOtp);
  };
  const handleCancel = () => {
    setOpenModalLogin(false);
  };
  const handleChangeLogin = () => {
    if (typeLogin === TYPE_LOGIN.loginPassword) {
      setTypeLogin(TYPE_LOGIN.loginOtp);
      setPhoneNumber("");
      setPassword("");
    } else if (typeLogin === TYPE_LOGIN.loginOtp) {
      setTypeLogin(TYPE_LOGIN.loginPassword);
      setPhoneNumber("");
      setPassword("");
    }
    setIsLoadingBtn(false);
    setStatusInput({
      phoneNumber: "",
      password: "",
    });
    setIsErrorPhoneOtp(false);
    setMessageError("");
    setIsLoginPW(true);
  };

  return (
    <>
      <Modal
        title={
          typeLogin === TYPE_LOGIN.loginPassword
            ? t("modal.modal_login.title")
            : t("modal.modal_login.title_otp")
        }
        open={open}
        onCancel={handleCancel}
        className="modal-login"
        getContainer={isGetContainer ? "" : false}
        width={800}
        footer={
          <div className={`foot-login ${isLoginPW ? "" : "login-pw-false"}`}>
            <Button
              onClick={handleOk}
              className="button-foot-modal"
              disabled={isLoadingBtn}
            >
              {isLoadingBtn ? (
                <Spin
                  style={{ color: "white" }}
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: 24, marginRight: "5px" }}
                      spin
                    />
                  }
                />
              ) : (
                ""
              )}
              {typeLogin === TYPE_LOGIN.loginPassword
                ? t("header.login")
                : t("modal.modal_login.login_otp")}
            </Button>
            <div onClick={handleChangeLogin} className="text-login">
              {typeLogin === TYPE_LOGIN.loginPassword
                ? t("modal.modal_login.login_with_otp")
                : t("modal.modal_login.login_with_password")}
            </div>
          </div>
        }
      >
        <div className="modal-login-body">
          {typeLogin === TYPE_LOGIN.loginPassword ? (
            <div className="modal-login-body-banner" />
          ) : null}

          {typeLogin === TYPE_LOGIN.loginPassword ? (
            <div className="modal-login-body-pass">
              <div className="box-input">
                <div className="box-input-label">
                  <span>{t("modal.modal_login.phone_number")}</span>
                  <span>*</span>
                </div>
                <div className="box-input-input">
                  <Input
                    value={phoneNumber}
                    status={statusInput.phoneNumber}
                    onChange={(e) => {
                      setStatusInput({ ...statusInput, phoneNumber: "" });
                      setPhoneNumber(handleNumericInput(e.target.value));
                      setMessageError("");
                      setIsLoginPW(true);
                    }}
                    placeholder={t(
                      "modal.modal_login.phone_number_placeholder",
                    )}
                    type="text"
                    inputMode="numeric"
                    ref={inputRefPhoneNumber}
                    className="number_input"
                  />
                </div>
              </div>

              <div className="box-input">
                <div className="box-input-label">
                  <span>{t("modal.modal_login.password")}</span>
                  <span>*</span>
                </div>
                <div className="box-input-input pass">
                  <Input
                    value={password}
                    status={statusInput.password}
                    onChange={(e) => {
                      setStatusInput({ ...statusInput, password: "" });
                      setPassword(e.target.value);
                      setMessageError("");
                      setIsLoginPW(true);
                    }}
                    type={showPassword ? "text" : "password"}
                    placeholder={t("modal.modal_login.password_placeholder")}
                    ref={inputRefPassWord}
                  />
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    className={`icon-eye  ${showPassword ? "show" : ""}`}
                  />
                </div>
                {messageError ? (
                  <div
                    style={{
                      fontStyle: "italic",
                      color: "red",
                      fontSize: "14px",
                      paddingTop: "10px",
                    }}
                  >
                    {messageError}
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="modal-login-body-otp">
              <Input
                value={phoneNumber}
                status={statusInput.phoneNumber}
                onChange={(e) => {
                  setStatusInput({ ...statusInput, phoneNumber: "" });
                  setPhoneNumber(handleNumericInput(e.target.value));
                  setIsErrorPhoneOtp(false);
                  setErrorMessageOpt("");
                  setCountdown(0);
                }}
                placeholder={t("modal.modal_login.phone_number_placeholder")}
                ref={inputRefPhoneNumberOtp}
                type="text"
                inputMode="numeric"
                className="number_input"
              />
              {isErrorPhoneOtp ? (
                <div
                  style={{
                    fontStyle: "italic",
                    color: "red",
                    fontSize: "14px",
                    paddingTop: "10px",
                  }}
                >
                  လည်ပတ်မှုတွင် အမှားအယွင်းတစ်ခု ဖြစ်ပွားခဲ့သည်။ ထပ်စမ်းကြည့်ပါ။
                </div>
              ) : null}
              {errorMessageOpt ? (
                <div
                  style={{
                    fontStyle: "italic",
                    color: "red",
                    fontSize: "14px",
                    paddingTop: "10px",
                  }}
                >
                  {errorMessageOpt}
                </div>
              ) : null}
            </div>
          )}
        </div>
      </Modal>
      <Modal
        title={t("modal.modal_login.title_confirm_otp")}
        open={openModalConfirm}
        onCancel={() => setOpenModalConfirm(false)}
        className="modal-confirm-otp"
        centered
        width={682}
        footer={
          <div className="foot-login">
            <Button
              onClick={handleConfirmOtp}
              className="button-foot-modal"
              disabled={isLoadingBtn}
            >
              {isLoadingBtn === 2 ? (
                <Spin
                  style={{ color: "white" }}
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: 24, marginRight: "5px" }}
                      spin
                    />
                  }
                />
              ) : (
                ""
              )}
              {t("modal.modal_login.confirm")}
            </Button>
          </div>
        }
      >
        <div className="modal-confirm-otp-body">
          <div onClick={handleBack} className="button-back">
            <span />
          </div>
          <div className="modal-confirm-otp-body-text-number">
            {t("modal.modal_login.text_confirm_otp").replace(
              "_PHONE_",
              phoneNumber,
            )}
          </div>
          <div className="box-input">
            <div className="label-input">
              {t("modal.modal_login.enter_otp")}
            </div>
            <div className="box-input-input">
              <OTPInput
                value={otp}
                onChange={(e) => {
                  // setOtp(e.replace(/\D/g, ""));
                  setOtp(e);
                  setMessageError("");
                }}
                numInputs={6}
                renderInput={(props) => (
                  <input {...props} inputMode="numeric" pattern="[0-9]*" />
                )}
              />
              {messageError ? (
                <div
                  style={{
                    fontStyle: "italic",
                    color: "red",
                    fontSize: "14px",
                    paddingTop: "10px",
                  }}
                >
                  {messageError}
                </div>
              ) : null}
            </div>
            {errorMessageOpt ? (
              <>
                <div
                  className="label-input"
                  style={{ position: "relative", color: "red" }}
                >
                  {errorMessageOpt}:{" "}
                  <span
                    onClick={() => handleOk(TYPE_LOGIN.loginOtp)}
                    style={{ pointerEvents: `${isLoadingBtn ? "none" : ""}` }}
                  >
                    {t("modal.modal_login.resend")}{" "}
                    {isLoadingBtn && isLoadingBtn !== 2 ? (
                      <div
                        style={{
                          position: "absolute",
                          right: "-30px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <Spin
                          style={{ color: "white" }}
                          indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                          }
                        />{" "}
                      </div>
                    ) : null}
                  </span>
                </div>
              </>
            ) : (
              <>
                {" "}
                {!countdown ? (
                  <div className="label-input" style={{ position: "relative" }}>
                    {t("modal.modal_login.resend_otp")}{" "}
                    <span
                      onClick={() => handleOk(TYPE_LOGIN.loginOtp)}
                      style={{ pointerEvents: `${isLoadingBtn ? "none" : ""}` }}
                    >
                      {t("modal.modal_login.resend")}{" "}
                      {isLoadingBtn && isLoadingBtn !== 2 ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "-30px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <Spin
                            style={{ color: "white" }}
                            indicator={
                              <LoadingOutlined style={{ fontSize: 24 }} spin />
                            }
                          />{" "}
                        </div>
                      ) : null}
                    </span>
                  </div>
                ) : (
                  <div className="label-input" style={{ position: "relative" }}>
                    စက္ကန့်
                    <span
                      style={{
                        pointerEvents: `${isLoadingBtn ? "none" : ""}`,
                        textDecoration: "none",
                      }}
                    >
                      {countdown}{" "}
                      {isLoadingBtn && isLoadingBtn !== 2 ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "-30px",
                            top: "50%",
                            transform: "translateY(-50%)",
                          }}
                        >
                          <Spin
                            style={{ color: "white" }}
                            indicator={
                              <LoadingOutlined style={{ fontSize: 24 }} spin />
                            }
                          />{" "}
                        </div>
                      ) : null}
                    </span>
                    ကြာပြီးနောက် OTP ကုဒ်ကို ပြန်ပို့ပါ။
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Modal>
      {/* <ModalNotifycation
				open={openModalNotification}
				handleCancel={() => setOpenModalNotification(false)}
				message={messageError}
			/> */}
    </>
  );
}

export default ModalLogin;
